import { getRelationships as getRelationshipsRepo } from "@/services/api/RolesPermissionsRepository";
import { useRelationshipsStore } from "@/zustand/relationshipsStore";
import { useLoaderStore } from "@/zustand/loaderStore";

let relationshipsPromise: Promise<void> | null = null;

export const getRelationships = () => {
  if (relationshipsPromise) return relationshipsPromise;
  useLoaderStore.getState().setLoading(true);
  relationshipsPromise = getRelationshipsRepo()
    .then((res) => {
      if (res) {
        useRelationshipsStore.getState().setRelationships(res);
      }
    })
    .finally(() => {
      useLoaderStore.getState().setLoading(false);
      relationshipsPromise = null;
    });
  return relationshipsPromise;
};
